module.exports = __webpack_public_path__ + "media/shot-whiff.df9e167f.mp3";